(function() {

  function overrideSaleBadge() {
    const wrap = document.querySelector('[data-price-off]');
    if (!wrap) return;

    const compareEl = document.querySelector('[data-compare-price]');
    const priceEl = document.querySelector('[data-product-price]');
    const badgeEl = wrap.querySelector('[data-price-off-badge]');
    const amountEl = wrap.querySelector('[data-price-off-amount]');
    const labelEl = wrap.querySelector('[data-price-off-label]');

    if (!compareEl || !priceEl || !badgeEl || !amountEl) return;

    // Extrair valores numéricos do texto (ex: "€130,00" → 13000)
    function parsePrice(el) {
      return parseInt(el.innerText.replace(/[^0-9]/g, ''));
    }

    const comparePrice = parsePrice(compareEl);
    const salePrice = parsePrice(priceEl);

    if (comparePrice > salePrice && comparePrice > 0) {
      const percent = Math.round(((comparePrice - salePrice) / comparePrice) * 100);
            amountEl.textContent = 'SAVE ' + percent + '%';
                  if (labelEl) labelEl.style.display = 'none';
                        badgeEl.classList.remove('hidden');
                        
    }
  }

  // Correr após o tema inicializar
  window.addEventListener('load', overrideSaleBadge);
  document.addEventListener('theme:variant:change', overrideSaleBadge);

  // Fallback com delay para garantir que o tema já correu
  setTimeout(overrideSaleBadge, 800);

  // GW: nos Loafers, mostrar apenas o numero EU nos botoes de tamanho
  function simplifySizeLabels(root) {
    var scope = root || document;
    if (!scope.querySelectorAll) return;
    var titles = scope.querySelectorAll('.option-title');
    titles.forEach(function (el) {
      var match = el.textContent.match(/\[\s*EU\s*([\d.]+)\s*\]/i);
      if (match) {
        el.textContent = match[1];
      }
    });
  }

  simplifySizeLabels();
  window.addEventListener('load', function () { simplifySizeLabels(); });
  document.addEventListener('theme:variant:change', function () { simplifySizeLabels(); });
  setTimeout(simplifySizeLabels, 800);

  var sizeLabelObserver = new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.matches && node.matches('.option-title')) {
          simplifySizeLabels(node.parentElement || document);
        } else if (node.querySelectorAll) {
          simplifySizeLabels(node);
        }
      });
    });
  });
  sizeLabelObserver.observe(document.body, { childList: true, subtree: true });

})();
